import styled from "styled-components";

export const ContainerCenter = styled.div`
  height: 100vh;
  width: 100%;
  background-color: #eff1f5;
  user-select: none;
`;

export const TopDiv = styled.div`
  display: flex;
  width: 100%;
`;

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100vh;
`;

export const ContainerCenterInside = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export const Header = styled.div`
  width: 96%;
  display: flex;
  justify-content: space-between;
  margin-top: 2.5rem;
  height: 2.68rem;
  Button {
    width: 9.7rem;
    height: 2.68rem;
  }
`;

export const InputDiv = styled.div`
  width: 20.8rem;
  display: flex;
  align-items: center;
  height: 2.68rem;
`;

export const Dashboard = styled.div`
  margin-top: 0.4rem;
  display: flex;
  flex-direction: column;
  width: 96%;
  align-items: center;
`;
